/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { identityProviderConnectionsGet } from "../funcs/identityProviderConnectionsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetIdentityProviderConnectionResult } from "../models/components/getidentityproviderconnectionresult.js";
import {
  GetIdentityProviderConnectionRequest,
  GetIdentityProviderConnectionSecurity,
} from "../models/operations/getidentityproviderconnection.js";
import { unwrapAsync } from "../types/fp.js";
export type IdentityProviderConnectionQueryData =
  GetIdentityProviderConnectionResult;

export function prefetchIdentityProviderConnection(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetIdentityProviderConnectionRequest | undefined,
  security?: GetIdentityProviderConnectionSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildIdentityProviderConnectionQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildIdentityProviderConnectionQuery(
  client$: GramCore,
  request?: GetIdentityProviderConnectionRequest | undefined,
  security?: GetIdentityProviderConnectionSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<IdentityProviderConnectionQueryData>;
} {
  return {
    queryKey: queryKeyIdentityProviderConnection({
      id: request?.id,
      gramSession: request?.gramSession,
    }),
    queryFn: async function identityProviderConnectionQueryFn(
      ctx,
    ): Promise<IdentityProviderConnectionQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(identityProviderConnectionsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyIdentityProviderConnection(
  parameters: { id?: string | undefined; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "identityProviderConnections", "get", parameters];
}
